'use client'

import * as React from 'react'
import * as SwitchPrimitives from '@radix-ui/react-switch'
import { cn } from '@/common/utils/utils.ts'

type SwitchProps = React.ComponentPropsWithoutRef<typeof SwitchPrimitives.Root> & {
    thumbIcon?: React.ReactNode
}

const Switch = React.forwardRef<React.ElementRef<typeof SwitchPrimitives.Root>, SwitchProps>(
    ({ className, thumbIcon, ...props }, ref) => {
        const rootClass = cn(
            'peer inline-flex h-5 w-9 shrink-0 cursor-pointer items-center rounded-full border-2 border-transparent shadow-sm transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background disabled:cursor-not-allowed disabled:opacity-50',
            'data-[state=checked]:bg-brand-emerald data-[state=unchecked]:bg-input',
            className,
        )

        const thumbClass = cn(
            'pointer-events-none flex items-center justify-center block h-4 w-4 rounded-full bg-background shadow-lg ring-0 transition-transform data-[state=checked]:translate-x-4 data-[state=unchecked]:translate-x-0',
        )

        return (
            <SwitchPrimitives.Root className={rootClass} {...props} ref={ref}>
                <SwitchPrimitives.Thumb className={thumbClass}>
                    {thumbIcon ? (
                        <span className="w-full h-full flex items-center justify-center">{thumbIcon}</span>
                    ) : null}
                </SwitchPrimitives.Thumb>
            </SwitchPrimitives.Root>
        )
    },
)

Switch.displayName = SwitchPrimitives.Root.displayName

export { Switch }
